import React,{useEffect} from 'react'
import Layout from '../Layout'
import FormAddTimologia from '../../components/timologia_components/FormAddTimologia'
import { useDispatch,useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { getMe } from '../../features/authSlice'
import BreadcrumbsEsoda from '../../components/BreadcrumbsEsoda'

const AddTimologio = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {isError} = useSelector((state=>state.auth));

    useEffect(()=>{
        dispatch(getMe());
    },[dispatch]);

    useEffect(()=>{
        if(isError){
            navigate("/");
        }
    },[isError,navigate]);
    return (
        <Layout>
            <BreadcrumbsEsoda />
            <FormAddTimologia/>
        </Layout>
    )
}

export default AddTimologio